import { z } from 'zod';

// Schema para login
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, 'Email é obrigatório')
    .email('Email inválido'),
  password: z
    .string()
    .min(1, 'Senha é obrigatória')
    .min(6, 'A senha deve ter pelo menos 6 caracteres')
});

// Schema para cadastro de usuário
export const signUpSchema = z.object({
  fname: z
    .string()
    .min(1, 'Nome é obrigatório')
    .min(2, 'Nome deve ter pelo menos 2 caracteres'),
  lname: z
    .string()
    .min(1, 'Sobrenome é obrigatório')
    .min(2, 'Sobrenome deve ter pelo menos 2 caracteres'),
  role: z
    .string()
    .min(1, 'Nível de acesso é obrigatório'),
  empresa: z
    .string()
    .optional(),
  cnpj: z
    .string()
    .optional()
    .refine((val) => !val || val.replace(/\D/g, '').length === 14, {
      message: 'CNPJ deve ter 14 dígitos'
    }),
  empresaId: z
    .string()
    .optional(),
  email: z
    .string()
    .min(1, 'Email é obrigatório')
    .email('Email inválido'),
  phone: z
    .string()
    .min(1, 'Telefone é obrigatório')
    .min(10, 'Telefone deve ter pelo menos 10 dígitos'),
  password: z
    .string()
    .min(1, 'Senha é obrigatória')
    .min(8, 'Senha deve ter pelo menos 8 caracteres')
    .max(16, 'Senha deve ter no máximo 16 caracteres')
    .regex(/^(?=.*[A-Z])/, 'Senha deve ter pelo menos 1 maiúscula')
    .regex(/^(?=.*[a-z])/, 'Senha deve ter pelo menos 1 minúscula')
    .regex(/^(?=.*\d)/, 'Senha deve ter pelo menos 1 número')
    .regex(/^(?=.*[-+_!@#$%^&*.,?])/, 'Senha deve ter pelo menos 1 caractere especial')
}).refine((data) => {
  // Validação condicional baseada no role
  if (data.role === 'ADMIN') {
    return data.empresa && data.empresa.length >= 2 && data.cnpj && data.cnpj.replace(/\D/g, '').length === 14;
  } else if (data.role === 'USER') {
    return data.empresaId && data.empresaId.length > 0;
  }
  return true;
}, {
  message: 'Campos obrigatórios não preenchidos corretamente',
  path: ['role']
});

// Schema para alteração de senha
export const changePasswordSchema = z.object({
  currentPassword: z
    .string()
    .min(1, 'Senha atual é obrigatória'),
  newPassword: z
    .string()
    .min(1, 'Nova senha é obrigatória')
    .min(8, 'Senha deve ter pelo menos 8 caracteres')
    .max(16, 'Senha deve ter no máximo 16 caracteres')
    .regex(/^(?=.*[A-Z])/, 'Senha deve ter pelo menos 1 maiúscula')
    .regex(/^(?=.*[a-z])/, 'Senha deve ter pelo menos 1 minúscula')
    .regex(/^(?=.*\d)/, 'Senha deve ter pelo menos 1 número')
    .regex(/^(?=.*[-+_!@#$%^&*.,?])/, 'Senha deve ter pelo menos 1 caractere especial'),
  confirmPassword: z
    .string()
    .min(1, 'Confirmação de senha é obrigatória')
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: 'Senhas não conferem',
  path: ['confirmPassword']
});

// Schema para pagamento
export const paymentSchema = z.object({
  valor: z
    .string()
    .min(1, 'Valor é obrigatório')
    .refine((val) => {
      const numericValue = val.replace(/[^\d,]/g, '');
      const amount = parseFloat(numericValue.replace(',', '.'));
      return amount > 0;
    }, 'Valor deve ser maior que zero'),
  nome: z
    .string()
    .min(1, 'Nome é obrigatório')
    .min(2, 'Nome deve ter pelo menos 2 caracteres'),
  sobrenome: z
    .string()
    .min(1, 'Sobrenome é obrigatório')
    .min(2, 'Sobrenome deve ter pelo menos 2 caracteres'),
  descricao: z
    .string()
    .min(1, 'Descrição é obrigatória')
    .min(5, 'Descrição deve ter pelo menos 5 caracteres'),
  phone: z
    .string()
    .min(1, 'Telefone é obrigatório')
    .min(10, 'Telefone deve ter pelo menos 10 dígitos')
});

export default {
  loginSchema,
  signUpSchema,
  changePasswordSchema,
  paymentSchema
};
